import React from 'react';
import { Btn, Container } from '../components/ui';
import { useLanguage } from '../context/LanguageContext';

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <section className="flex min-h-[60vh] items-center px-5 py-20 sm:px-8">
      <Container className="text-center">
        <div className="font-display text-7xl font-extrabold text-brand">404</div>
        <h1 className="mt-4 font-display text-2xl font-bold text-slate-900 dark:text-white">Page not found</h1>
        <p className="mx-auto mt-3 max-w-md text-base text-slate-600 dark:text-slate-300">The page you’re looking for doesn’t exist or has moved.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Btn to="/" arrow>{t('common.back')} home</Btn>
          <Btn to="/demo" variant="outline">{t('common.requestDemo')}</Btn>
        </div>
      </Container>
    </section>
  );
}
